import { Component } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { HomeComponent } from '../home.component';

@Component({
  selector: 'app-user-menubutton',
  template: `
    <a class="menu-button" href="#" (click)="appMain.onMenuButtonClick($event)">
      <i class="pi cm-bars"></i>
    </a>
  `,
})
export class AppUserMenuButtonComponent {

  constructor(
    public appMain: HomeComponent,
		public app: AppComponent,
  ) {}
}
